<template>
    <!-- Rendering in a separate html file fails -->
    <div>
        <v-card-text>
            <quill-editor
                theme="snow"
                content-type="html"
                toolbar="full"
                v-model:content="editorContent"></quill-editor>
        </v-card-text>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default defineComponent({
    components: { QuillEditor },
    emits: ["update:content"],
    props: {
        content: { type: String, required: true }
    },
    computed: {
        editorContent: {
            get(): string {
                return this.content;
            },
            set(v: string) {
                this.$emit("update:content", v);
            }
        }
    }
});
</script>
